import React from "react";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { cx } from "../../utils/cx";

export function SystemAvatar({ read }) {
  return (
    <div
      className={cx(
        "h-10 w-10 rounded-full flex items-center justify-center",
        read
          ? "bg-surface-sunken text-text-muted"
          : "bg-primary-800 dark:bg-primary-50 text-primary dark:text-primary-500"
      )}
    >
      <MapPinIcon className="h-5 w-5" strokeWidth={1.75} />
    </div>
  );
}
